import axiosInstance from './axiosInstance';

// 获取联系我们关于图片
export const getContactAboutImages = () => {
  return axiosInstance.get('/contact-about/images');
};

// 更新联系我们关于图片
export const updateContactAboutImage = (formData) => {
  return axiosInstance.post('/contact-about/images', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 获取关于我们文本内容
export const getAboutUsContent = (lang = 'zh') => {
  return axiosInstance.get('/about-us/', {
    params: { lang: lang }
  });
};

// 更新关于我们文本内容
export const updateAboutUsContent = (content) => {
  return axiosInstance.put('/about-us/', content);
};

// 新增颜色含义API
export const addColorMeaning = (colorData) => {
  return axiosInstance.post('/about-us/colors', colorData);
};

// 删除颜色含义API
export const deleteColorMeaning = (colorId) => {
  return axiosInstance.delete(`/about-us/colors/${colorId}`);
};

// 新增更新颜色含义API
export const updateColorMeaning = (colorId, colorData) => {
  return axiosInstance.put(`/about-us/colors/${colorId}`, colorData);
};